var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10 create-payment-plan" },
    [
      _c("el-page-header", {
        attrs: {
          title: _vm.$t("common.back"),
          content: _vm.$t("payment_plan.create.title")
        },
        on: { back: _vm.handleGoBack }
      }),
      _vm._v(" "),
      _vm.recipientRecord
        ? _c(
            "el-card",
            { staticClass: "mt-20" },
            [
              _c(
                "el-form",
                {
                  ref: "paymentPlanForm",
                  staticClass: "create-payment-plan__form",
                  attrs: { model: _vm.form }
                },
                [
                  _c("div", { staticClass: "create-payment-plan__recipient" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("payment_plan.create.recipient")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.recipientRecord.name))])
                  ]),
                  _vm._v(" "),
                  _vm.recipientRecord.invoice_documents.length > 0
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "create-payment-plan__invoices",
                          attrs: { prop: "invoices" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.$t("payment_plan.create.invoices"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              ref: "invoicesTable",
                              attrs: {
                                data: _vm.recipientRecord.invoice_documents
                              },
                              on: {
                                "selection-change":
                                  _vm.handleInvoiceSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "invoice_number",
                                  label: _vm.$t("invoice_table.invoice_number")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "due_date",
                                  label: _vm.$t("invoice_table.due_date")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "open_amount",
                                  label: _vm.$t("invoice_table.open_amount")
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$formatter.toCurrency(
                                                scope.row.open_amount,
                                                scope.row.amount_currency
                                              )
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3596754517
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recipientRecord.credit_notes.length > 0
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "create-payment-plan__credit_notes",
                          attrs: { prop: "creditNotes" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.$t("payment_plan.create.credit_notes"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              ref: "creditNotesTable",
                              attrs: { data: _vm.recipientRecord.credit_notes },
                              on: {
                                "selection-change":
                                  _vm.handleCreditNoteSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "credit_note_number",
                                  label: _vm.$t(
                                    "credit_note_table.credit_note_number"
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "issue_date",
                                  label: _vm.$t("credit_note_table.issue_date")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "open_amount",
                                  label: _vm.$t("credit_note_table.open_amount")
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$formatter.toCurrency(
                                                scope.row.open_amount,
                                                scope.row.amount_currency
                                              )
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  641494869
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recipientRecord.debit_notes.length > 0
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "create-payment-plan__debit_notes",
                          attrs: { prop: "debitNotes" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.$t("payment_plan.create.debit_notes"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              ref: "debitNotesTable",
                              attrs: { data: _vm.recipientRecord.debit_notes },
                              on: {
                                "selection-change":
                                  _vm.handleDebitNoteSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "debit_note_number",
                                  label: _vm.$t(
                                    "debit_note_table.debit_note_number"
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "issue_date",
                                  label: _vm.$t("debit_note_table.issue_date")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "open_amount",
                                  label: _vm.$t("debit_note_table.open_amount")
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$formatter.toCurrency(
                                                scope.row.open_amount,
                                                scope.row.amount_currency
                                              )
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  641494869
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recipientRecord.payment_documents.length > 0
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "create-payment-plan__payments",
                          attrs: { prop: "payments" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.$t("payment_plan.create.payments"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              ref: "paymentsTable",
                              attrs: {
                                data: _vm.recipientRecord.payment_documents
                              },
                              on: {
                                "selection-change":
                                  _vm.handlePaymentSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "payment_number",
                                  label: _vm.$t("payment_table.payment_number")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "issue_date",
                                  label: _vm.$t("payment_table.issue_date")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "open_amount",
                                  label: _vm.$t("payment_table.open_amount")
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$formatter.toCurrency(
                                                scope.row.open_amount,
                                                scope.row.amount_currency
                                              )
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  641494869
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "create-payment-plan__total_amount" },
                    [
                      _c("h3", [
                        _vm._v(
                          _vm._s(_vm.$t("payment_plan.create.total_amount"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$formatter.toCurrency(
                              _vm.totalAmount,
                              _vm.recipientRecord.invoice_documents[0]
                                ?.amount_currency
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "create-payment-plan__conditions" },
                    [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.$t("payment_plan.create.conditions")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          attrs: { "label-width": "260px", prop: "conditions" },
                          model: {
                            value: _vm.form.conditions,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "conditions", $$v)
                            },
                            expression: "form.conditions"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "payment_plan.create.conditions_interest_applied"
                                )
                              }
                            },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.form.conditions.interestApplied,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.conditions,
                                      "interestApplied",
                                      $$v
                                    )
                                  },
                                  expression: "form.conditions.interestApplied"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "payment_plan.create.conditions_interest"
                                )
                              }
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { type: "number", step: ".01" },
                                  model: {
                                    value: _vm.form.conditions.interest,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.conditions,
                                        "interest",
                                        $$v
                                      )
                                    },
                                    expression: "form.conditions.interest"
                                  }
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%")
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "payment_plan.create.conditions_indemnification_applied"
                                )
                              }
                            },
                            [
                              _c("el-switch", {
                                model: {
                                  value:
                                    _vm.form.conditions.indemnificationApplied,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.conditions,
                                      "indemnificationApplied",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.conditions.indemnificationApplied"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "payment_plan.create.conditions_indemnification"
                                )
                              }
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { type: "number", step: ".01" },
                                  model: {
                                    value: _vm.form.conditions.indemnification,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.conditions,
                                        "indemnification",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.conditions.indemnification"
                                  }
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%")
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "payment_plan.create.conditions_indemnification_min"
                                )
                              }
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { type: "number", step: ".01" },
                                  model: {
                                    value:
                                      _vm.form.conditions.indemnificationMin,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.conditions,
                                        "indemnificationMin",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.conditions.indemnificationMin"
                                  }
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$formatter.toCurrencySymbol(
                                          _vm.recipientRecord
                                            .invoice_documents[0]
                                            ?.amount_currency
                                        )
                                      )
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "payment_plan.create.conditions_indemnification_max"
                                )
                              }
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { type: "number", step: ".01" },
                                  model: {
                                    value:
                                      _vm.form.conditions.indemnificationMax,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.conditions,
                                        "indemnificationMax",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.conditions.indemnificationMax"
                                  }
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$formatter.toCurrencySymbol(
                                          _vm.recipientRecord
                                            .invoice_documents[0]
                                            ?.amount_currency
                                        )
                                      )
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "payment_plan.create.constraints_installment_frequency"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "Select" },
                                  model: {
                                    value:
                                      _vm.form.conditions.installmentFrequency,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.conditions,
                                        "installmentFrequency",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.conditions.installmentFrequency"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "payment_plan.create.constraints_monthly"
                                      ),
                                      value: "MONTHLY"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "payment_plan.create.constraints_weekly"
                                      ),
                                      value: "WEEKLY"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "create-payment-plan__total_amount_with_conditions"
                    },
                    [
                      _c("h3", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "payment_plan.create.total_amount_with_conditions"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$formatter.toCurrency(
                              _vm.totalWithConditions,
                              _vm.recipientRecord.invoice_documents[0]
                                ?.amount_currency
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "create-payment-plan__constraints" },
                    [
                      _c("h3", [
                        _vm._v(
                          _vm._s(_vm.$t("payment_plan.create.constraints"))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "create-payment-plan__constraint_control"
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass:
                                "create-payment-plan__constraint_form_item",
                              attrs: { error: _vm.constraintInputWarning }
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass:
                                    "create-payment-plan__constraint_input",
                                  attrs: {
                                    type: "number",
                                    min: _vm.constraintInputMin,
                                    max: _vm.constraintInputMax,
                                    step: _vm.constraintInputStep
                                  },
                                  on: {
                                    input: _vm.handleConstraintInputChange,
                                    blur: _vm.commitConstraintInput,
                                    change: _vm.commitConstraintInput
                                  },
                                  model: {
                                    value: _vm.constraintInputDraft,
                                    callback: function($$v) {
                                      _vm.constraintInputDraft = $$v
                                    },
                                    expression: "constraintInputDraft"
                                  }
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "prepend" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass:
                                            "create-payment-plan__constraint_select",
                                          model: {
                                            value: _vm.selectedConstraintType,
                                            callback: function($$v) {
                                              _vm.selectedConstraintType = $$v
                                            },
                                            expression: "selectedConstraintType"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "payment_plan.create.constraints_max_installments"
                                              ),
                                              value: "MAX_INSTALLMENTS"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "payment_plan.create.constraints_max_installment_amount"
                                              ),
                                              value: "MAX_INSTALLMENT_AMOUNT"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "create-payment-plan__total_amount_with_conditions"
                    },
                    [
                      _c(
                        "h3",
                        [
                          _vm.form.conditions.installmentFrequency == "WEEKLY"
                            ? [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("payment_plan.create.weekly_amount")
                                  )
                                )
                              ]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("payment_plan.create.monthly_amount")
                                  )
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$formatter.toCurrency(
                              _vm.displayInstallmentAmount,
                              _vm.recipientRecord.invoice_documents[0]
                                ?.amount_currency
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.paymentPreview.visible
                    ? _c(
                        "div",
                        { staticClass: "create-payment-plan__payment_preview" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "create-payment-plan__payment_preview_row"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(_vm.previewPeriodLabelKey, {
                                      period: 1
                                    })
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$formatter.toCurrency(
                                      _vm.paymentPreview.regularAmount,
                                      _vm.recipientRecord.invoice_documents[0]
                                        ?.amount_currency
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.paymentPreview.installments > 2
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "create-payment-plan__payment_preview_row"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(_vm.previewPeriodLabelKey, {
                                          period: 2
                                        })
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$formatter.toCurrency(
                                          _vm.paymentPreview.regularAmount,
                                          _vm.recipientRecord
                                            .invoice_documents[0]
                                            ?.amount_currency
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.paymentPreview.installments > 3
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "create-payment-plan__payment_preview_row"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "payment_plan.create.payment_example_ellipsis"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "payment_plan.create.payment_example_ellipsis"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "create-payment-plan__payment_preview_row"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(_vm.previewPeriodLabelKey, {
                                      period: _vm.paymentPreview.installments
                                    })
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$formatter.toCurrency(
                                      _vm.paymentPreview.lastAmount,
                                      _vm.recipientRecord.invoice_documents[0]
                                        ?.amount_currency
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "create-payment-plan__first_installment",
                      attrs: { prop: "dateFirstInstallment" }
                    },
                    [
                      _c("h3", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("payment_plan.create.first_installment")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        attrs: { type: "date" },
                        model: {
                          value: _vm.form.dateFirstInstallment,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dateFirstInstallment", $$v)
                          },
                          expression: "form.dateFirstInstallment"
                        }
                      }),
                      _vm._v(" "),
                      _vm.validateDateFirstInstallment
                        ? _c(
                            "el-alert",
                            { attrs: { type: "warning", closable: false } },
                            [_vm._v(_vm._s(_vm.validateDateFirstInstallment))]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "create-payment-plan__cta" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.loading },
                          on: { click: _vm.handleFormSubmit }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("payment_plan.create.submit")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }